
// export const base_path = "/";
// export const img_path = "/";

// export const COMPANY_LOCATION = "Next to Karama Post Office,Dubai";
// export const COMPANY_PHONE_NUMBER = "+(971) 4342-6666";
// export const COMPANY_MAIL = "info@example.com";
// export const COMPANY_NAME = "Emirates Secretarial Services";

// export const PUBLIC_API_URL = "http://localhost:5001/api/";
// export const SIGNALR_HUB_URL = "http://localhost:5001/notificationHub";
// export const IMAGE_SERVER_PATH = "http://localhost:5001";


export const base_path = "/";
export const img_path = "/";

export const COMPANY_LOCATION = "Next to Karama Post Office,Dubai";
export const COMPANY_PHONE_NUMBER = "+(971) 4342-6666";
export const COMPANY_MAIL = "info@example.com";
export const COMPANY_NAME = "Emirates Secretarial Services";





export const PUBLIC_API_URL = "https://uberevisa.com/api/";
export const SIGNALR_HUB_URL = "https://uberevisa.com/notificationHub";
export const IMAGE_SERVER_PATH = "https://uberevisa.com";

